import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailPosComponent } from './detail-pos.component';
import { DetailPosRoutingModule } from './detail-pos-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ActionBarComponent } from './action-bar/action-bar.component';
import { PosGeneralDataComponent } from './pos-general-data/pos-general-data.component';
import { PosLocationDataComponent } from './pos-location-data/pos-location-data.component';
import { PosProductsComponent } from './pos-products/pos-products.component';
import { PosBrandsComponent } from './pos-brands/pos-brands.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '../directives/directives.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    DetailPosComponent,
    ActionBarComponent,
    PosGeneralDataComponent,
    PosLocationDataComponent,
    PosProductsComponent,
    PosBrandsComponent,
  ],
  imports: [
    CommonModule,
    DetailPosRoutingModule,
    TranslateModule.forChild({
      extend: true,
    }),
    SharedModule,
    FormsModule,
    NgbPaginationModule,
    DirectivesModule,
    ReactiveFormsModule,
  ],
  exports: [DetailPosComponent, NgbPaginationModule],
})
export class DetailPosModule {}
